export default __webpack_public_path__ + "static/media/icon-two-buss-traslado.0ff76202.svg";